/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.observers = new Map();
    }
    EventEmitter.prototype.on = function (events, listener) {
        var _this = this;
        events.split(' ').forEach(function (event) {
            _this.observers.set(event, _this.observers.get(event) || []);
            _this.observers.get(event).push(listener);
        });
        return this;
    };
    EventEmitter.prototype.off = function (event, listener) {
        if (!this.observers.get(event))
            return;
        if (!listener) {
            this.observers.delete(event);
            return;
        }
        this.observers.set(event, this.observers.get(event).filter(function (l) { return l !== listener; }));
    };
    EventEmitter.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.observers.get(event)) {
            var observers = this.observers.get(event);
            var cloned = [];
            cloned = cloned.concat(observers);
            cloned.forEach(function (observer) {
                observer.apply(void 0, __spreadArray([], __read(args), false));
            });
        }
        if (this.observers.get('*')) {
            var observers = this.observers.get('*');
            var cloned = [];
            cloned = cloned.concat(observers);
            cloned.forEach(function (observer) {
                observer.apply(observer, __spreadArray([event], __read(args), false));
            });
        }
    };
    return EventEmitter;
}());
export default EventEmitter;
